import { HTTP_METHODS } from "@/constants/httpMethods";
import axios from "axios";

const api = axios.create({
  baseURL:
    typeof window === "undefined"
      ? process.env.INTERNAL_API_URL || process.env.NEXT_PUBLIC_API_URL
      : "/api/proxy",
  timeout: 50000,
  headers: {
    "Content-Type": "application/json",
  },
});

if (typeof window === "undefined") {
  console.log(`[======= INTERNAL API =======] -> ${process.env.INTERNAL_API_URL}`);

  // Connectivity check — DNS + TCP erişim testi
  const internalUrl = process.env.INTERNAL_API_URL;
  if (internalUrl) {
    fetch(internalUrl, { method: "HEAD", signal: AbortSignal.timeout(5000) })
      .then((res) => console.log(`[======= INTERNAL API HEALTH =======] -> BASARILI (${res.status})`))
      .catch((err) => {
        const code = err.code || err.message;
        const aciklama =
          code === "ENOTFOUND" ? "DNS cozumlenemedi - hostname bulunamadi" :
          code === "ECONNREFUSED" ? "Baglanti reddedildi - servis ayakta degil veya port kapali" :
          code === "ECONNRESET" ? "Baglanti sifirlandi - ag katmaninda kesildi" :
          code === "ETIMEDOUT" || code === "TimeoutError" ? "Zaman asimi - firewall veya ag kurali engelliyor olabilir" :
          code;
        console.error(`[======= INTERNAL API HEALTH =======] -> BASARISIZ: ${code} (${aciklama})`);
      });
  }
}

api.interceptors.response.use(
  (response) => response,
  (error) => {
    // TODO: Add client-side error handling (toast notifications) here
    // when the request does not have a custom error handler.
    // e.g. if (!error.config?._hasErrorHandler && typeof window !== "undefined") { ... }
    return Promise.reject(error);
  },
);

/**
 * Generic request function to handle all API calls
 * @param {string} method - HTTP method (GET, POST, PUT, DELETE, etc.)
 * @param {string} url - API endpoint
 * @param {object} [payload] - Request data (becomes params for GET/DELETE, data for others)
 * @param {object} [headers] - Optional custom headers
 * @param {boolean} [hasErrorHandler] - Whether this request has a custom error handler
 * @param {AbortSignal} [signal] - Optional AbortSignal to cancel the request
 * @returns {Promise} - Axios response
 */
export async function request({
  method,
  url,
  payload,
  headers,
  hasErrorHandler = false,
  signal,
}) {
  const upperMethod = method.toUpperCase();
  const usesParams =
    upperMethod === HTTP_METHODS.GET || upperMethod === HTTP_METHODS.DELETE;

  const config = {
    method,
    url,
    headers,
    _hasErrorHandler: hasErrorHandler,
    ...(signal ? { signal } : {}),
    ...(usesParams ? { params: payload } : { data: payload }),
  };

  // TODO: Geçici SSR debug log — proxy doğrulaması sonrası kaldırılacak
  if (typeof window === "undefined") {
    console.log(`[api] SSR → ${api.defaults.baseURL}${url}`);
  }

  const response = await api(config);
  return response.data;
}

// Fetch timing instrumentation
export async function timedFetch(label, fn) {
  console.time(label);
  try {
    return await fn();
  } finally {
    console.timeEnd(label);
  }
}

export default api;
